<template>
  <section class="advert-app-workspace">
    <!-- 顶栏操作和过滤框 -->
    <table-toolbar :search.sync="search" :show-refresh="true" :show-export="true" :show-column-settings="true" :columns="columnOptions" :visible-columns.sync="visibleColumns" :default-columns="defaultColumns" :fixed-columns="['# ID', '应用名称', '操作']" @refresh="handleReset" @export="handleExport">
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddPoses" class="btn-action">新增应用</el-button>
      </template>
    </table-toolbar>

    <!-- 表格主体 -->
    <table-page :loading="loading" :empty="tables.length === 0" :show-top-pagination="false" :show-bottom-pagination="false" @retry="fetchData">
      <el-table
        :data="tables"
        stripe
        style="width: 100%"
        class="premium-table"
      >
        <el-table-column key="col-id" prop="id" width="90">
          <template slot="header">
            <span class="premium-header-title"><span class="header-icon-hash">#</span> ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-name" prop="name" min-width="160">
          <template slot="header">
            <span class="premium-header-title">应用名称</span>
          </template>
          <template slot-scope="scope">
            <el-link type="primary" class="cell-channel-name" @click="handleUpdatePoses(scope.$index, scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column key="col-appKey" v-if="visibleColumns.includes('appKey')" prop="appKey" min-width="130">
          <template slot="header">
            <span class="premium-header-title">AppKey</span>
          </template>
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.appKey" v-if="scope.row.appKey" />
            <span v-else class="cell-text-gray">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-appSecret" v-if="visibleColumns.includes('appSecret')" prop="appSecret" min-width="130">
          <template slot="header">
            <span class="premium-header-title">AppSecret</span>
          </template>
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.appSecret" v-if="scope.row.appSecret" />
            <span v-else class="cell-text-gray">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-notifyUrl" v-if="visibleColumns.includes('notifyUrl')" prop="notifyUrl" min-width="180">
          <template slot="header">
            <span class="premium-header-title">通知地址</span>
          </template>
          <template slot-scope="scope">
            <ext-text-popover :content="scope.row.notifyUrl" v-if="scope.row.notifyUrl" />
            <span v-else class="cell-text-gray">-</span>
          </template>
        </el-table-column>

        <el-table-column key="col-poses" v-if="visibleColumns.includes('poses')" prop="poses" min-width="130">
          <template slot="header">
            <span class="premium-header-title">广告位</span>
          </template>
          <template slot-scope="scope">
            <el-tooltip content="点击编辑广告位" placement="top" :open-delay="400">
              <div class="editable-cell" @click="handleUpdatePoses(scope.$index, scope.row)"><span>配置广告位</span><i class="el-icon-edit-outline editable-cell-icon"></i></div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column key="col-actions" width="80" align="center">
          <template slot="header">
            <span class="premium-header-title">操作</span>
          </template>
          <template slot-scope="scope">
            <el-dropdown @command="handleActionCommand($event, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown" class="premium-dropdown-menu">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i> 编辑应用
                </el-dropdown-item>
                <el-dropdown-item command="delete" style="color: #ef4444;">
                  <i class="el-icon-delete" style="color: #ef4444;"></i> 删除应用
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <!-- dialog -->
    <poses-dialog
      :posesData="posesData"
      :dialogVisible="dialogVisible"
      @handleCloseDialog="dialogVisible=false"
      @handleSaveDialog="handlePosesDialogChange"
    ></poses-dialog>
  </section>
</template>

<script>
import PosesDialog from './PosesDialog'
import api from '@/api/channel'
import ExtTextPopover from '@/components/ExtTextPopover/index.vue'
import TableToolbar from '@/components/TableToolbar/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'index',
  components: { PosesDialog, ExtTextPopover, TableToolbar, TablePage },
  created () {
    this.fetchData()
  },
  data () {
    return {
      tableData: [],
      search: '',
      dialogVisible: false,
      posesData: {},
      visibleColumns: ['appKey', 'appSecret', 'notifyUrl', 'poses'],
      loading: false
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    tables () {
      const search = this.search
      if (search) {
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(search.toLowerCase()) > -1
          })
        })
      }
      return this.tableData
    },
    columnOptions () {
      return [
        { prop: 'appKey', label: 'AppKey' },
        { prop: 'appSecret', label: 'AppSecret' },
        { prop: 'notifyUrl', label: '通知地址' },
        { prop: 'poses', label: '广告位' }
      ]
    },
    defaultColumns () {
      return this.columnOptions.map(item => item.prop)
    }
  },
  watch: {
    appId (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      api.getAdnetGames().then(res => {
        this.tableData = res
      }).finally(() => {
        this.loading = false
      })
    },
    // 修改应用及广告位
    handleUpdatePoses (index, rowData) {
      const data = Object.assign({}, rowData)
      data.poses = data.poses ? JSON.parse(data.poses) : []
      this.posesData = data
      this.dialogVisible = true
    },
    // 新增应用
    handleAddPoses () {
      const id = this.tableData.length ? this.tableData[this.tableData.length - 1].id : 0
      this.posesData = {
        id: id + 1,
        poses: [{ posId: '', posName: '', rewardName: '', rewardAmount: '', pangolinPosId: '', pangolinAppSecret: '', tencentPosId: '', tencentSecret: '' }],
        appKey: '',
        appSecret: '',
        name: '',
        notifyUrl: ''
      }
      this.dialogVisible = true
    },
    // 接收子组件
    handlePosesDialogChange (value) {
      this.dialogVisible = value
      this.fetchData()
    },
    // 删除应用
    handleDeletePoses (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteAdnetGames(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    handleReset () {
      this.fetchData()
    },
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleUpdatePoses(index, row)
      } else if (command === 'delete') {
        this.handleDeletePoses(row.id, index)
      }
    },
    handleExport () {
      const worksheet = XLSX.utils.json_to_sheet(this.tables)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '广告应用')
      XLSX.writeFile(workbook, `广告应用-${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`)
    }
  }
}
</script>

<style scoped>
.advert-app-workspace {
  padding: 16px 24px;
}

/* 过滤筛选卡片 */
.filter-card {
  margin-top: 0 !important;
  margin-bottom: 20px;
  padding: 16px 24px;
  border-radius: var(--border-radius-card);
  background: var(--bg-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-left-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-right-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-action {
  flex-shrink: 0;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.btn-reset {
  background-color: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  height: 32px;
  padding: 0 16px;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.btn-reset:hover {
  background-color: #F1F5F9 !important;
  color: var(--text-main) !important;
  border-color: #CBD5E1 !important;
}

.btn-setting {
  flex-shrink: 0;
  background-color: #FFFFFF !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-setting:hover {
  background-color: #F8FAFC !important;
  border-color: #CBD5E1 !important;
  color: var(--text-main) !important;
}

.search-input {
  width: 220px;
  flex-shrink: 0;
}

.search-input :deep(.el-input__inner) {
  border-radius: 8px;
  border-color: #E2E8F0;
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  background-color: #FFFFFF;
  color: var(--text-main);
  transition: all 0.2s ease;
}

.search-input :deep(.el-input__inner:hover) {
  border-color: #CBD5E1;
}

.search-input :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* 表格卡片样式 */
.table-card {
  padding: 20px;
  border-radius: var(--border-radius-card);
  background-color: var(--bg-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
  font-weight: 600;
  color: var(--text-muted);
}

.cell-channel-name {
  font-weight: 700 !important;
  font-size: 13.5px !important;
  text-decoration: none !important;
}

.cell-text-gray {
  color: #64748B;
  font-size: 13px;
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.editable-cell { min-height: 30px; display: flex; align-items: center; gap: 8px; padding: 3px 8px; border: 1px solid transparent; border-radius: 8px; color: var(--primary-color); cursor: pointer; transition: all 0.2s ease; }
.editable-cell:hover { border-color: rgba(37, 99, 235, 0.22); background: rgba(37, 99, 235, 0.06); }
.editable-cell-icon { margin-left: auto; opacity: 0; transition: opacity 0.2s ease; }
.editable-cell:hover .editable-cell-icon { opacity: 1; }

.app-id-tag {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  color: #475569;
  background: #F1F5F9;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  display: inline-block;
  letter-spacing: 0.2px;
}

.app-name-link {
  font-weight: 600;
  font-size: 14px;
  text-decoration: none !important;
}

.app-name-link:hover {
  text-decoration: none !important;
}

.poses-config-link {
  font-weight: 600;
  font-size: 13px;
  text-decoration: none !important;
}

.poses-config-link:hover {
  text-decoration: none !important;
}

/* 操作列三点图标 */
.action-btn {
  font-size: 12px;
  border: 1px solid #E2E8F0;
  color: #64748B;
  background: #ffffff;
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: #F1F5F9;
  color: var(--text-main);
  border-color: #CBD5E1;
}

/* 列配置 Popover 内部样式 */
.popover-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-main);
  padding: 6px 4px;
}

.popover-divider {
  height: 1px;
  background: #E2E8F0;
  margin: 6px 0;
}

.popover-body-scroll {
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;
}

.popover-body-scroll::-webkit-scrollbar {
  width: 4px;
}

.popover-body-scroll::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 2px;
}

.popover-body-scroll :deep(.el-checkbox) {
  display: block;
  margin-bottom: 8px;
  margin-right: 0;
}
</style>
